import { entityExportAdapter } from '../reducers/ExportReducer';

export const {
  selectById: getExportByName,
  selectIds: getExportIds,
  selectEntities: getExports,
  selectTotal: getExportCount,
} = entityExportAdapter.getSelectors((state) => state.export);
